import '@Styles/auth-form.scss';
import { ApplicationType, InsightExceptionType } from './Enums';
import { htmlEncode } from './Helpers/CommonUtils';

declare const model: {
    applicationType: ApplicationType;
    htmlNotSupported: boolean;
    isLicenseExpired: boolean;
    insightExceptionType?: InsightExceptionType;
    error: string;
};
$(() => {
    const resources = strings.errorControl;
    const message = $('.message');
    const backLink = $('.back-link');

    $('.logo>img').attr('alt', resources.logo);

    const appName = ApplicationType.getName(model.applicationType);
    const backLinkText = appName ? resources.backTo.format(appName) : resources.backToDashboard;
    backLink.text(backLinkText);

    let errorText;

    if (model.htmlNotSupported) {
        errorText = resources.htmlNotSupported.format(window.navigator.userAgent, getBrowserFullVersion());
    } else {
        switch (model.insightExceptionType) {
            case InsightExceptionType.unknownSession:
                errorText = strings.logoutControl.sessionExpired;
                break;
            case InsightExceptionType.serviceUnavailable:
                errorText = strings.serverExceptions.serviceUnavailable;
                break;
            case InsightExceptionType.licenseError:
            case InsightExceptionType.clientException:
                errorText = model.error;
                break;
            default:
                errorText = altosoft.isDebug && model.error ? model.error : resources.unhandledException;
                break;
        }
    }

    let messageHtml = htmlEncode(errorText).replaceAll('\r\n', '<br>');
    if (model.isLicenseExpired) {
        const adminConsoleLink = '<a href="/Insight/Admin/Default.aspx">' + ApplicationType.getName(ApplicationType.admin) + '</a>';
        messageHtml = messageHtml.replace('{AdminConsole}', adminConsoleLink);
    }
    message.html(messageHtml);

    function getBrowserFullVersion(): string {
        const allRegex = [/(chrome)[ \/]([\w.]+)/i, /(webkit)[ \/]([\w.]+)/i, /(opera)(?:.*version|)[ \/]([\w.]+)/i, /(msie) ([\w.]+)/i];

        const userAgent = navigator.userAgent;

        let matches = allRegex.map(r => r.exec(userAgent)).find(matches => matches != null);
        if ((matches == null || matches.length === 0) && !userAgent.includes('compatible')) {
            matches = /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(userAgent);
        }
        return matches != null && matches.length > 2 ? matches[2] : '0';
    }
});
